var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.36,
    height: 19.36,
    viewBox: "0 0 19.36 19.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a2a5b9",
    d: "M17.092,1.513h-.908V0H14.672V1.513H4.689V0H3.176V1.513H2.269A2.271,2.271,0,0,0,0,3.781v13.31A2.271,2.271,0,0,0,2.269,19.36H17.092a2.271,2.271,0,0,0,2.269-2.269V3.781A2.271,2.271,0,0,0,17.092,1.513Zm.756,15.579a.757.757,0,0,1-.756.756H2.269a.757.757,0,0,1-.756-.756V7.109H17.848Zm0-11.5H1.513V3.781a.757.757,0,0,1,.756-.756h.908V4.538H4.689V3.025h9.983V4.538h1.513V3.025h.908a.757.757,0,0,1,.756.756Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.473 8.399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.196 0.27)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.436 8.399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.233 0.27)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 8.399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.27 0.27)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.362 8.399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.307 0.27)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.325 8.399)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.344 0.27)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.473 11.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.196 0.307)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.436 11.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.233 0.307)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 11.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.27 0.307)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.362 11.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.307 0.307)"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.473 14.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.196 0.344)"
  })))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.436 14.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.233 0.344)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.399 14.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.27 0.344)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.362 14.325)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.307 0.344)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.325 11.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#a2a5b9",
    width: 1,
    height: 1,
    transform: "translate(0.344 0.307)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.775f6f612819960e07a69368f09b0bcf.svg";
export { ForwardRef as ReactComponent };